// const [deviceFormData, setDeviceFormData] = React.useState({
//     brand: "",
//     company: "",
//     dataProtocol: "",
//     description: "",
//     id: "",
//     model: "",
//     password: "",
//     software: "",
//     softwareVersion: "",
//     status: "ACTIVE",
// });

export const assignment_fields = () => [
  {
    key: 'appointedName',
    type: 'text',
    inputType: 'text',
    placeHolder: 'Teslim Edilen İsim',
    defaultValue: '',
  },
  {
    key: 'appointedSurname',
    type: 'text',
    inputType: 'text',
    placeHolder: 'Teslim Edilen Soyisim',
    defaultValue: '',
  },
  {
    key: 'appointedPhonenumber',
    type: 'text',
    inputType: 'text',
    placeHolder: 'Teslim Edilen GSM',
    defaultValue: '',
  },

  // {
  //   key: 'brand',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Marka',
  //   defaultValue: '',
  // },
  // {
  //   key: 'company',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Şirket',
  //   defaultValue: '',
  // },
  // {
  //   key: 'description',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Açıklama',
  //   defaultValue: '',
  // },
  // {
  //   key: 'model',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Model',
  //   defaultValue: '',
  // },
  // {
  //   key: 'password',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Şifre',
  //   defaultValue: '',
  // },
  // {
  //   key: 'software',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Yazılım',
  //   defaultValue: '',
  // },
  // {
  //   key: 'softwareVersion',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'Yazılım Versiyonu',
  //   defaultValue: '',
  // },
];
